<template>
    <div>
        <!-- Loader Component -->
        <Loader :visible="isLoading" :text="loadingText" />

        <ConfirmationModal :show="confirmDeleteRow" @close="confirmDeleteRow = false">
            <template #title>Conferma Eliminazione Modello Contratto</template>

            <template #content>
                Sei sicuro di voler eliminare <strong>{{ rowDeletion.Codice }}</strong>?
            </template>

            <template #footer>
                <button 
                    @click="confirmDeleteRow = false;" 
                    class="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 mr-2"
                >
                    Annulla
                </button>
                <button 
                    @click="rowDeletion.toDelete = true; confirmDeleteRow = false;" 
                    class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                >
                    Conferma
                </button>
            </template>
        </ConfirmationModal>
        
        <div class="p-6 pb-0">
            <BreadCrumbs :navigation="navigation" />
        </div>
        <div class="p-6">
            <!-- Risultati -->
            <div class="bg-white rounded-md shadow-lg">
                <div class="flex justify-between items-center p-4 border-b">
                    <div>
                        <h3 class="text-lg font-semibold">Risultati Ricerca</h3>
                        <p class="text-gray-600">{{ contractModels.length }} modello/i contratto trovato/i</p>
                    </div>
                    <div class="text-right">
                        <button class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 mr-3 rounded-md" @click="showAddModal()">
                        <i class="fa fa-plus mr-1"></i> Aggiungi
                        </button>
                        <button class="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md" @click="saveLines">
                        <i class="fa fa-save"></i> Salva Modifiche
                        </button>
                    </div>
                </div>
                <div>
                    <!-- Container che occupa tutto lo spazio disponibile -->
                    <div class="overflow-y-auto" style="height: calc(90vh - 230px); min-height: 300px;">
                        <table class="min-w-full text-sm">
                            <!-- Header fisso -->
                            <thead class="bg-gray-100 sticky top-0 z-10 text-sm">
                                <tr>
                                    <th class="py-3 px-4 border-b text-left bg-gray-100">Codice</th>
                                    <th class="py-3 px-4 border-b text-left bg-gray-100">Descrizione</th>
                                    <th class="py-3 px-4 border-b text-left bg-gray-100">Tipo Intervento</th>
                                    <th class="py-3 px-4 border-b text-left bg-gray-100">Numero di Contratti attivi/totali</th>
                                    <th class="py-3 px-4 border-b text-left bg-gray-100">Disabilitato</th>
                                    <th class="py-3 px-4 border-b text-left bg-gray-100">Azioni</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white">
                                <tr v-for="(contractModel, index) in filterList" :key="contractModel.Codice" class="hover:bg-gray-50">
                                    <td class="py-3 px-4 border-b">{{ contractModel.Codice }}</td>
                                    <td class="py-3 px-4 border-b"><input v-model="contractModel.Descrizione" type="text" class="p93__input"></td>
                                    <td class="py-3 px-4 border-b"><input v-model="contractModel.TipoIntervento" type="text" class="p93__input"></td>
                                    <td class="py-3 px-4 border-b" v-html="contractModel.TotalContracts > 0 ? ('<a class=\'bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600\' href=\'' + route('modules.contratti.ricerca')+'?ContractModel='+contractModel.Codice +'\' target=\'_blank\'><b>'+ contractModel.ActiveContracts + '/' + contractModel.TotalContracts +'</b></a>') : contractModel.ActiveContracts + '/' + contractModel.TotalContracts "></td>
                                    <td class="py-3 px-4 border-b">
                                        <label class="cursor-pointer">
                                            <input type="checkbox" v-model="contractModel.Disabled" style="display:none"/>
                                            <div class="relative w-10 h-5 bg-gray-300 rounded-full transition-colors duration-200"
                                            :class="{ 'bg-red-500': contractModel.Disabled }">
                                            <span
                                                class="absolute left-0 top-0 h-5 w-5 bg-white rounded-full shadow transform transition-transform duration-200"
                                                :class="{ 'translate-x-5': contractModel.Disabled }"></span>
                                            </div>
                                        </label>
                                    </td>
                                    <td class="py-3 px-4 border-b">
                                        <button v-if="contractModel.TotalContracts == 0" @click="rowDeletion=contractModel; confirmDeleteRow=true"
                                                class="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 text-sm"
                                            ><i class="fa fa-trash mr-1"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showAddContractModel" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50" @mousedown="showAddContractModel=false">
            <div ref="pkgModal" class="bg-white p-6 rounded-md w-full max-w-md relative" @mousedown.stop>
            <div @mousedown="startDrag($event, $refs.pkgModal)" class="cursor-move mb-4 -mt-2 -mx-2 p-2">
                <h2 class="text-xl select-none">Aggiunta Modello Contratto</h2>
            </div>
                <div class="mb-4">
                    <label class="block text-gray-700">Codice</label>
                    <input v-model="newLine.Codice" class="p93__input" maxlength="9">
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700">Descrizione</label>
                    <input v-model="newLine.Descrizione" class="p93__input" maxlength="50">
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700">Tipo Intervento</label>
                    <input v-model="newLine.TipoIntervento" class="p93__input" maxlength="20">
                </div>
                <div class="mb-4">
                    <label class="block text-gray-700">Disabilitato</label>
                    <label class="cursor-pointer">
                            <input type="checkbox" v-model="newLine.Disabled" style="display:none"/>
                            <div class="relative w-10 h-5 bg-gray-300 rounded-full transition-colors duration-200"
                            :class="{ 'bg-red-500': newLine.Disabled }">
                            <span
                                class="absolute left-0 top-0 h-5 w-5 bg-white rounded-full shadow transform transition-transform duration-200"
                                :class="{ 'translate-x-5': newLine.Disabled }"></span>
                            </div>
                    </label>
                </div>
                

                <div class="flex justify-end">   
                    <button type="button" @click="showAddContractModel = false" class="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-md mr-2">Annulla</button>
                    <button type="button" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md" @click="addNewLine">{{ 'Aggiungi' }}</button>
                </div>

            </div>
        </div>
    </div>

    <ToastNotification :show="toast.show" :message="toast.message" :type="toast.type"
        @update:show="toast.show = $event" />
</template>

<script>
import { Link, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Loader from '@/Components/Loader.vue';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import ToastNotification from '@/Components/ToastNotification.vue';
import { useLoader } from '@/Composables/useLoader.js';
import axios from 'axios';

export default {
    props: ['contractModels'],
    components: {
        Link,
        BreadCrumbs,
        Loader,
        ConfirmationModal,
        ToastNotification,
    },
    setup() {
        const { isLoading, loadingText, showLoader, hideLoader, withLoader, withLoaderSafe, withInertiaLoader } = useLoader();

        return {
            isLoading,
            loadingText,
            showLoader,
            hideLoader, withLoader,
            withLoaderSafe,
            withInertiaLoader
        };
    },
    data() {
        return {
            navigation: [
                { name: 'Dashboard', href: route('dashboard') },
                { name: 'Contratti', href: route('modules.home', 'contratti') },
                { name: 'Gestione Modelli Contratti', href: route('modules.contratti.gestione-modelli') }
            ],
            newLine: {
                Codice: '',
                Descrizione: '',
                TipoIntervento: '',
                Disabled: false,
                DefaultSconto: 0,
                TotalContracts: 0,
                ActiveContracts: 0,
                new: true
            },
            confirmDeleteRow : false,
            rowDeletion: null,
            showAddContractModel: false,
            toast: {
                show: false,
                message: '',
                type: 'success'
            },
        };
    },
    computed: {
        filterList() {
            return this.contractModels.filter(x => !x.toDelete).sort((a,b) => { return a.Codice.localeCompare(b.Codice)}); 
        }
    },
    methods: {
        showToast(message, type = 'success') {
            this.toast.message = message;
            this.toast.type = type;
            this.toast.show = true;
        },
        showAddModal(){
            this.newLine= {
                Codice: '',
                Descrizione: '',
                TipoIntervento: '',
                Disabled: false,
                DefaultSconto: 0,
                TotalContracts: 0,
                ActiveContracts: 0,
                new: true
            };
            this.showAddContractModel = true;
        },
        addNewLine()
        {
            this.contractModels.push(this.newLine);
            this.showAddContractModel = false
        },
        async saveLines()
        {
            const result = await this.withLoaderSafe(
                async () => {
                    const response = await axios.post(route('modules.contratti.salva-modelli'), {
                        rows: this.contractModels
                    });
                    this.showToast('Modelli salvati con successo', 'success');
                    return response;
                },
                `Salvataggio in corso...`,
                (error) => {
                    console.error('Errore durante il salvataggio dei modelli:', error);
                    this.showToast('Si è verificato un errore durante il salvataggio dei modelli', 'error');
                }
            );
        }
    }
};
</script>